import { LOYALTY_LEVEL_NAMES } from '../constants/levelNames'

export const LoyaltyLevelsTranslations: Record<LOYALTY_LEVEL_NAMES, string> = {
  [LOYALTY_LEVEL_NAMES.level01]: 'loyalty-program.levels-1-common',
  [LOYALTY_LEVEL_NAMES.level02]: 'loyalty-program.levels-2-common',
  [LOYALTY_LEVEL_NAMES.level03]: 'loyalty-program.levels-3-common',
  [LOYALTY_LEVEL_NAMES.level04]: 'loyalty-program.levels-4-common',
  [LOYALTY_LEVEL_NAMES.level05]: 'loyalty-program.levels-5-common',
}
